import { actions, selectors } from './';
import { selectors as accountSelectors } from '../account';
import { connect } from '../store/connect';
import { AUTHORIZATIONS } from '../authorizations/authorizations';
import { HistoryBase } from '../util/history-base';
const { CAN_SEE_USER_HISTORY } = AUTHORIZATIONS;

class UserHistory extends HistoryBase {
    static get properties() {
        return {
            ...super.properties,
            eUserId: {
                type: String,
            },
            eSiteId: {
                type: String,
            },
        };
    }

    get historyTitle() {
        return 'User History';
    }

    get emptyMessage() {
        return 'No history found for this user.';
    }

    updated(changedProps) {
        if (changedProps.has('eUserId')) {
            const { eUserId, eSiteId, authorizations } = this;
            if (authorizations?.includes(CAN_SEE_USER_HISTORY) && eUserId && eSiteId) {
                this.actions.fetchUserHistory({ eUserId, eSiteId });
            }
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const userData = selectors.selectedUserDataSelector(state);
        return {
            eUserId: userData?.eUserId,
            eSiteId: userData?.eSiteId,
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
            historyRecords: selectors.userHistoryRecordsSelector(state),
            isLoadingHistory: selectors.isLoadingUserHistorySelector(state),
        };
    };
};

const combinedActions = {
    ...actions,
};

customElements.define('user-history', connect(mapStateToProps, combinedActions)(UserHistory));
